module.exports = "/_next/static/images/residencial-b171054e5c4f7cffc1ecefee8d0757b4.svg";